export default __webpack_public_path__ + "static/media/Icon ionic-md-globe.56fd734c.svg";